<template>
  <div class="businesses-page">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'businesses-page',
}

</script>
